<div *ngIf="!selectedPerson" class="person-search">
  <span translate>CourtBookingSave.SearchPlayerText</span>
  <form [formGroup]="form" novalidate *ngIf="form">
    <input id="person-search" class="person-search-input" type="text" formControlName="search" autocomplete="off"
      placeholder="{{'ChangePlayer.SearchPlayerPlaceholder' | translate}}">
    <span class="ic-player-search person-search-icon"></span>
  </form>
  <div class="person-search-list-dropdown">
    <div class="person-search-list  " role="menu" aria-labelledby="person-search"
      *ngIf="(players$ | async).loaded">
      <div *ngFor="let player of (players$ | async).items" (click)="selectPerson(player)">
        <app-court-booking-player-info [showRemoveButton]="false" [person]="player"></app-court-booking-player-info>
      </div>
    </div>
  </div>
</div>
<div *ngIf="selectedPerson">
  <div class="person-search person-search-selected">
    <app-court-booking-player-info [showRemoveButton]="true" [person]="selectedPerson"
      (removePerson)="clearSelectedPerson()"></app-court-booking-player-info>
  </div>
  <div>
    <app-player-rules-message *ngIf="playerRules" [rules]="playerRules" [categoryName]="categoryName$ | async">
    </app-player-rules-message>
  </div>

</div>
